import requisitantesRotas from "./requisitantes/RequisitantesRotas"
import fornecedoresRotas from "./fornecedores/FornecedoresRotas"
import demandantesRotas from "./demandantes/DemandantesRotas"
import gerentesRotas from "./gerentes/GerentesRotas"
import finalizacaoRotas from "./finalizacao/FinalizacaoRotas"
import financeiroRotas from "./financeiro/FinanceiroRotas"

export default {
    path: 'despesasgerais',
    name: 'DespesasGerais',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        requisitantesRotas, 
        fornecedoresRotas, 
        demandantesRotas,
        gerentesRotas,
        finalizacaoRotas,
        financeiroRotas
    ]
}